import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const CouplesNames = ({ data, onNext }) => {
  const [form, setForm] = useState({
    senderName: data.senderName || '',
    recipientName: data.recipientName || '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.senderName && form.recipientName) {
      onNext(form);
    }
  };

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-1">Who's this for? 💕</h2>
      <p className="text-gray-500 text-sm mb-6">Enter both names for your love card</p>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Your Name</label>
          <div className="relative">
            <SafeIcon name="User" className="absolute left-4 top-1/2 -translate-y-1/2 text-purple-400" />
            <input
              type="text" required value={form.senderName}
              onChange={(e) => setForm({ ...form, senderName: e.target.value })}
              placeholder="Your name"
              className="w-full pl-12 pr-4 py-4 rounded-xl border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-100 outline-none"
            />
          </div>
        </div>

        <div className="flex justify-center">
          <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center">
            <span className="text-xl">❤️</span>
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Their Name</label>
          <div className="relative">
            <SafeIcon name="Heart" className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-400" />
            <input
              type="text" required value={form.recipientName}
              onChange={(e) => setForm({ ...form, recipientName: e.target.value })}
              placeholder="Their name"
              className="w-full pl-12 pr-4 py-4 rounded-xl border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-100 outline-none"
            />
          </div>
        </div>

        <button type="submit" className="w-full bg-gradient-to-r from-purple-500 to-violet-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-purple-200">
          Continue →
        </button>
      </form>
    </motion.div>
  );
};

export default CouplesNames;